
import {map} from 'rxjs/operators';
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ClientDetailVM } from "../models";
import { BaseService } from "./base.service";
import { GenericPagingVM, MessageVM } from "../models";
import { SessionBookingVM } from "../models/SessionBookingVM";
import { ClientDashboardVM } from "../models/ClientDashboardVM";
import { SessionCreditVM } from "../models/SessionCreditVM";
import { MessagePartyVM } from "../models/MessagePartyVM";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class AccountService extends BaseService {

  public newSessionBooking: SessionBookingVM;
  public confirmedSessionBooking: SessionBookingVM;
  public messageOtherParty: MessagePartyVM = null;

  constructor(private http: HttpClient) {
    super();
  }

  public getDashboard(incSessionHistory: boolean): Observable<ClientDashboardVM> {
    var url = (incSessionHistory) ? '/api/account/dashboard/true' : '/api/account/dashboard';
    return this.http.get(url, this.getHttpOptions(true)).pipe(
      map(resp => resp as ClientDashboardVM));
  }

  public updateProfile(profile: ClientDetailVM): Observable<boolean> {
    return this.http.patch('/api/account/profile', profile, this.getHttpOptions(true)).pipe(
      map(resp => !!resp));
  }

  public setProfileImage(base64Img: string): Observable<boolean> {
    return this.http.post('/api/account/profile-image', JSON.stringify(base64Img), this.getHttpOptions(true)).pipe(
      map(resp => !!resp));
  }

  public getProfile(): Observable<ClientDetailVM> {
    return this.http.get('/api/account/profile', this.getHttpOptions(true)).pipe(
      map(resp => resp as ClientDetailVM));
  }

  public getMessages(pagingObject: GenericPagingVM): Observable<GenericPagingVM> {

    pagingObject.pageNo = pagingObject.pageNo || 1;
    pagingObject.pageSize = pagingObject.pageSize || 10;

    var url = '/api/account/messages?pageNo='
      + pagingObject.pageNo
      + '&pageSize=' + pagingObject.pageSize;

    if (pagingObject.nextPagingToken != null) {
      url += '&continueToken=' + btoa(pagingObject.nextPagingToken);
    }

    return this.http.get(url, this.getHttpOptions(true)).pipe(
      map(resp => resp as GenericPagingVM));
  }

  public getUnreadMessagesCount(): Observable<number> {
    var url = '/api/account/messages/unreadcount';
    return this.http.get(url, this.getHttpOptions(true)).pipe(
      map(resp => resp as number));
  }

  public getMessage(id: string): Observable<MessageVM[]> {
    return this.http.get('/api/account/messages/' + id, this.getHttpOptions(true)).pipe(
      map(resp => resp as MessageVM[]));
  }

  public sendMessage(vm: MessageVM): Observable<boolean> {
    return this.http.post('/api/account/messages/', vm, this.getHttpOptions(true)).pipe(
      map(resp => !!resp));
  }

  public canReply(otherPartyId: string): Observable<boolean> {
    return this.http.get('/api/account/messages/' + otherPartyId + '/can-reply', this.getHttpOptions(true)).pipe(
      map(resp => !!resp));
  }

  public proceedSessionBooking(sessionBooking: SessionBookingVM) {
    this.newSessionBooking = sessionBooking;
  }

  public reserveBooking(vm: SessionBookingVM): Observable<SessionBookingVM> {
    return this.http.post('/api/account/reserve-session', vm, this.getHttpOptions(true)).pipe(
      map(resp => {
        return resp as SessionBookingVM;
      }));
  }

  public commitBooking(vm: SessionBookingVM): Observable<any> {
    return this.http.post('/api/account/session', vm, {...this.getHttpOptions(true), observe: 'response'}).pipe(
      map(resp => resp));
  }

  public canCancelSession(vm: SessionBookingVM): Observable<boolean> {
    return this.http.get('/api/account/session/' + vm.id + '/cancel-status', this.getHttpOptions(true)).pipe(
      map(resp => !!resp));
  }

  public cancelSession(vm: SessionBookingVM): Observable<boolean> {
    return this.http.post('/api/account/session/cancel', vm, this.getHttpOptions(true)).pipe(
      map(resp => !!resp));
  }

  public getSessionCredits(status: boolean): Observable<SessionCreditVM[]> {
    var url = '/api/account/session-credits/' + ((status) ? 'active' : 'inactive');
    return this.http.get(url, this.getHttpOptions(true)).pipe(
      map(resp => resp as SessionCreditVM[]));
  }

  public getSessionCreditsByProfessional(mbNo: string): Observable<SessionCreditVM[]> {
    var url = '/api/account/session-credits/' + mbNo + '/active';
    return this.http.get(url, this.getHttpOptions(true)).pipe(
      map(resp => resp as SessionCreditVM[]));
  }

  public isSessionCreditValid(creditId: string): Observable<SessionCreditVM> {
    var url = '/api/account/session-credits/' + creditId + '/validate';
    return this.http.get(url, this.getHttpOptions(true)).pipe(
      map(resp => resp as SessionCreditVM));
  }

}
